import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../i18n/language.service';

@Component({
  selector: 'app-who-do-we-work-for',
  standalone: false,
  templateUrl: './who-do-we-work-for.component.html',
  styleUrls: ['./who-do-we-work-for.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhoDoWeWorkForComponent {
  constructor(public language: LanguageService) {}
}
